import { render, staticRenderFns } from "./Trajet-patient.vue?vue&type=template&id=13ff22d8&scoped=true"
import script from "./Trajet-patient.vue?vue&type=script&lang=js"
export * from "./Trajet-patient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ff22d8",
  null
  
)

export default component.exports